import { getLastInvite } from '../../../common/garageHelpers';

export default function isLastBookingInvitePending(booking) {
  if (typeof booking.garageInvites === 'undefined' || booking.garageInvites.length === 0) return false;
  const lastInvite = getLastInvite(booking);
  return lastInvite && lastInvite.status === 'pending';
}
